<template>
  <div class="activities-smart-notifications-banner">
    <div class="content ml-30 my-20">
      <div class="title mb-15">✨ Now there's an easier way to check members' activity</div>
      <div class="subtitle mb-30">
        Introducing Smart Notifications: Get notified about changes in your members' and teams' work metrics and step in
        early to offer extra assistance or encouragement when needed.
      </div>
      <div class="actions d-flex gap-20">
        <a
          v-track:click="buttonClick"
          :href="smartNotificationsSettingsUrl"
          class="btn btn-primary"
        >
          <span class="plus fa fa-plus" /> Create notification
        </a>
        <a
          v-track:click="buttonClick"
          :href="smartNotificationsSettingsUrl"
          class="btn btn-outline-default"
        >
          View all templates
        </a>
      </div>
    </div>
    <div class="banner-illustration text-right">
      <img :src="ACTIVITIES_SMART_NOTIFICATIONS_BANNER_ILLUSTRATION" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ACTIVITIES_SMART_NOTIFICATIONS_BANNER_ILLUSTRATION } from '~/rails_assets';

export default {
  name: 'ActivitiesSmartNotificationsBanner',
  data: () => ({
    ACTIVITIES_SMART_NOTIFICATIONS_BANNER_ILLUSTRATION,
    buttonClick: Object.freeze({
      label: 'SN activity banner selected',
    }),
  }),
  computed: {
    ...mapGetters(['smartNotificationsSettingsUrl']),
  },
};
</script>
